import type { ReactElement } from 'react';
import React from 'react';
import { View, StyleSheet } from 'react-native';
import type { BoxProps, SizeTypes, PaletteTypes } from '../TagLabel.types';
import { TagLabelPalette, TagLabelSize } from '../TagLabel.types';
import { useBoxStyles } from '../styles';

export const Box = (props: BoxProps): ReactElement => {
  const {
    palette = TagLabelPalette.primary as PaletteTypes,
    size = TagLabelSize.medium as SizeTypes,
    children,
    testID,
  } = props;

  const useStyleState = useBoxStyles(palette, size);

  return (
    <View
      style={StyleSheet.flatten([styles.buttonBox, useStyleState()])}
      testID={testID}
    >
      {children}
    </View>
  );
};

const styles = StyleSheet.create({
  buttonBox: {
    height: 24,
    paddingHorizontal: 8,
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    borderRadius: 4,
  },
});
